import { create } from 'zustand';
import type { ActiveWorkResponse, ActiveWorkRun } from '@sr-test-wizard/shared';
import { api } from '../lib/api';

interface ActiveWorkState {
  /** Team-wide busy runs (Kanban + strip live flags). */
  runs: ActiveWorkRun[];
  loading: boolean;
  error: string | null;
  fetch: () => Promise<void>;
  clear: () => void;
}

/**
 * Live Sidekick activity across the team. Used by the Kanban overlays and
 * merged into the personal Active strip for pinned runs.
 */
export const useActiveWorkStore = create<ActiveWorkState>((set) => ({
  runs: [],
  loading: false,
  error: null,
  clear: () => set({ runs: [], error: null }),
  fetch: async () => {
    set({ loading: true, error: null });
    try {
      const data = await api.get<ActiveWorkResponse>('/api/dashboard/activity');
      set({ runs: data.runs, loading: false });
    } catch (e: unknown) {
      set({ loading: false, error: (e as Error).message });
    }
  },
}));
